import React, { useState, useEffect } from 'react';

interface ProjectDataProps {
  name?: string;
  startDate?: string;
  endDate?: string;
  taskName?: string;
  location?: string;
}

const ProjectData: React.FC<ProjectDataProps> = (props) => {
  const [name, setName] = useState(props.name || '');
  const [startDate, setStartDate] = useState(props.startDate || '');
  const [endDate, setEndDate] = useState(props.endDate || '');
  const [taskName, setTaskName] = useState(props.taskName || '');
  const [location, setLocation] = useState(props.location || '');

  useEffect(() => {
    if (props.name) setName(props.name);
    if (props.startDate) setStartDate(props.startDate);
    if (props.endDate) setEndDate(props.endDate);
    if (props.taskName) setTaskName(props.taskName);
    if (props.location) setLocation(props.location);
  }, [props]);

  return (
    <div className="p-5 px-1 flex flex-col gap-4 rounded-lg w-full m-auto" dir="ltr">
      {/* Conditionally render rows */}
      {name && (
        <div className="flex justify-end items-center border-b pb-2">
          <div className="text-base font-bold text-[#333333] font-['Tajawal'] w-full">{name}</div>
          <div className="border-b border-[#d38d2d] w-1/3"></div>
          <div className="text-base font-normal text-[#333333] font-['Tajawal'] w-1/3 text-end">العميل</div>
        </div>
      )}
      {startDate && (
        <div className="flex justify-end items-center border-b pb-2">
          <div className="text-base font-bold text-[#333333] font-['Tajawal'] w-full">{startDate}</div>
          <div className="border-b border-[#d38d2d] w-1/3"></div>
          <div className="text-base font-normal text-[#333333] font-['Tajawal'] w-full text-end">تاريخ البداية</div>
        </div>
      )}
      {endDate && (
        <div className="flex justify-end items-center border-b pb-2">
          <div className="text-base font-bold text-[#333333] font-['Tajawal'] w-full">{endDate}</div>
          <div className="border-b border-[#d38d2d] w-1/3"></div>
          <div className="text-base font-normal text-[#333333] font-['Tajawal'] w-full text-end">تاريخ الانتهاء</div>
        </div>
      )}
      {taskName && (
        <div className="flex justify-end items-center border-b pb-2">
          <div className="text-base font-bold text-[#333333] font-['Tajawal'] w-full">{taskName}</div>
          <div className="border-b border-[#d38d2d] w-1/3"></div>
          <div className="text-base font-normal text-[#333333] font-['Tajawal'] w-full text-end">المهام</div>
        </div>
      )}
      {location && (
        <div className="flex justify-end items-center border-b pb-2">
          <div className="text-base font-bold text-[#333333] font-['Tajawal'] w-full">{location}</div>
          <div className="border-b border-[#d38d2d] w-1/3"></div>
          <div className="text-base font-normal text-[#333333] font-['Tajawal'] w-full text-end">مكان المشروع</div>
        </div>
      )}
    </div>
  );
};

export default ProjectData;
